import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';
import AvatarPerson from '../AvatarPerson';

const StyledWrap = styled.div`
  position: relative;
`;

const StyleIcon = styled(Icon)`
  height: ${rem('52px')};
  width: ${rem('51px')};
  ${mediaqueries.greaterThan('tablet')`
    height: ${rem('74px')};
    width: ${rem('74px')};
  `};
`;

const WrapperAvatar = styled.span`
  height: ${rem('36px')};
  left: 0.7rem;
  position: absolute;
  top: 0.5rem;
  width: ${rem('36px')};
  ${mediaqueries.greaterThan('tablet')`
    height: ${rem('54px')};
    left: 0.92rem;
    top: 0.62rem;
    width: ${rem('54px')};
  `};
`;

const StyledAvatar = styled(AvatarPerson)`
  font-size: 150%;
  background-color: ${props => props.theme.colors.grayLighter};
  width: 100%;
  height: 100%;
  max-width: ${rem('52px')};
  border: none;
  font-size: ${rem('16px')};
  ${mediaqueries.greaterThan('tablet')`
    font-size: ${rem('24px')};
  `};
`;

export { StyledWrap, WrapperAvatar, StyleIcon, StyledAvatar };
